var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#7a8596;}.cls-4{fill:#59667c;}.cls-5{fill:#959cb3;}.cls-6{fill:#b2b7c8;}.cls-7{fill:#3b485e;}.cls-8{fill:#747e91;}.cls-9{fill:#b72c2c;}.cls-10{fill:#eb5c0b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    className: "cls-1",
    x: 8,
    y: 8,
    width: 144,
    height: 144
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.46,114.09,116.9,57.65a25.72,25.72,0,0,0,33.33-33.33l-13,13-11.47-3.08-3.08-11.47,13-13A25.72,25.72,0,0,0,102.35,43.1L45.91,99.54a27.3,27.3,0,1,0,14.55,14.55ZM28,132a10.28,10.28,0,1,1,14.54,0A10.27,10.27,0,0,1,28,132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.61,144A27.29,27.29,0,0,1,16,144l12-12a10.28,10.28,0,0,0,14.54-14.54l83.17-83.17,11.47,3.08,13-13A25.72,25.72,0,0,1,116.9,57.65L60.46,114.09A27.32,27.32,0,0,1,54.61,144Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.7,106.74,35.05,29.08l5.35-5.34L20.43,8,8,20.43l15.74,20,5.34-5.35,77.66,77.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.72,109.72l-95.5-95.5L8,20.43l15.74,20,5.34-5.35,77.66,77.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.62,114l14.55,14.54,6.32-.08,14.09-14.09v-6.22L114,93.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M93.62,114l14.55,14.54,6.32-.08,7-7-17.66-17.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M108.17,128.56l19.21,19.21a14.42,14.42,0,1,0,20.39-20.39l-19.2-19.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M108.17,128.56l19.21,19.21a14.42,14.42,0,0,0,20.4,0l-29.41-29.41Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaService);
export default __webpack_public_path__ + "static/media/ka_service.95dfc3e6e27163741e81086448e462fc.svg";
export { ForwardRef as ReactComponent };